import Error from 'components/alerts/Error'
import { Text } from 'components/common/form/modules/input/Text';
import { updateCurrentUser } from 'components/graphql/queries';
import { AppConfig } from 'config/app';
import React from 'react'
import { Redirect } from "react-router";
import { ClipLoader } from 'react-spinners';
import { Button, Card } from 'reactstrap';
import { AuthenticationService } from 'services/api/Authentication.service';
import { fetchGraphQL } from 'services/graphql/GraphQL';

export default class FinishAccountSetup extends React.Component<
    { [label: string]: any },
    {
        name: string;
        lastName: string;
        password: string;
        passwordRepeat: string;
        error: boolean;
        loading: boolean;
        change: boolean;
        email: string;
        message: string;
        done: boolean;
    }
    > {

    private AuthService = new AuthenticationService();
    constructor(props) {
        super(props)
        this.state = {
            error: false,
            loading: true,
            email: '',
            name: '',
            lastName: '',
            password: '',
            passwordRepeat: '',
            change: false,
            message: '',
            done: false
        }
        this.onChange = this.onChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public onChange = (e: any) => {
        const newState = this.state;
        newState[e.target.name] = e.target.value;
        this.setState({ ...newState, change: true });
    };

    public handleSubmit() {
        if (!this.state.change) {
            return;
        }

        const { email, name, lastName, password, passwordRepeat } = this.state;
        this.setState({ change: false, message: '' });

        if (name.length < 3) {
            this.setState({
                message: 'First name has to be at least 3 characters long',
            });
            return;
        }
        if (lastName.length < 1) {
            this.setState({
                message: 'Last name has to be at least 1 characters long',
            });
            return;
        }
        if (password !== '' && passwordRepeat !== '') {

            if (password.length < 6) {
                this.setState({
                    message: 'Password has to be at least 6 characters long',
                });
                return;
            }


            if (passwordRepeat !== password) {
                this.setState({ message: 'Passwords do not match' });
                return;
            }

        } else if (password === '' && passwordRepeat !== '') {

            this.setState({
                message: 'Enter password',
            });
            return;

        } else if (password !== '' && passwordRepeat === '') {

            this.setState({
                message: 'Enter password again',
            });
            return;

        } else {
            this.setState({
                message: 'Enter password',
            });
            return;
        }

        // if there isn no message it means all fields are valid
        fetchGraphQL(updateCurrentUser(), undefined, {
            email,
            name,
            lastname: lastName,
            password,
        }).then(data => {
            if (data.user.update === true) {
                this.setState({ done: true })
            }
        });
    }

    public componentDidMount() {

        const relativeURL = window.location.pathname.split('/');
        const email = relativeURL[2];
        const password = relativeURL[3];

        this.AuthService.authWithPassword(email.toLowerCase(), password)
            .then((res: any) => {
                if (res.status === 'error') {
                    this.setState({
                        error: true,
                        loading: false
                    })
                } else {
                    this.setState({
                        loading: false,
                        email
                    })
                }
            })

    }

    public render() {

        if (this.state.loading) {
            return <div style={{ justifyContent: 'center', display: 'flex', paddingTop: '100px' }}>
                <ClipLoader color={"#000000"} loading={true} />
            </div>;
        }

        if (this.state.error) {
            return <div className="div_holder_2" style={{ textAlign: 'center' }}>
                <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                    <p />
                    <img src={require('./Dark-logo.png')} width={screen.width > 768 ? '15%' : '40%'} height={screen.width > 768 ? '15%' : '40%'} />
                </div>
                <p style={{ paddingTop: '100px', textAlign: 'center', width: '100%', alignItems: 'center' }}>
                    <h3>
                        One-time link has been used or is invalid.</h3><br />
                    <a href={AppConfig.hostUrl + '/'}>
                        <button className='new-button-save'>
                            GO TO LOGIN
                        </button>
                    </a>
                </p>
            </div>
        }

        if (this.state.done) {
            return <Redirect to="/login" />;
        }

        return <div className="div_holder_2" style={{ paddingBottom: '25px' }}>
            <Card className='div_holder_2' style={{ maxWidth: '650px' }} >
                <div className='div_holder_3' style={{ display: 'flex', justifyContent: 'center', paddingBottom: '75px' }}>
                    <div>
                        <p />
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <img src={require('./Dark-logo.png')} width='35%' height='35%' />
                        </div>
                        <p><br /></p>
                        <h3 style={{ color: '#020102' }}>Welcome to Isotope!</h3>
                        <p>
                            <br />
                            Finish setting up your account using this one-time link.
                            You will be asked to login after completion.
                            After logging in, set up payments to start creating events,
                            or start selling tickets for an event that you were already added to by an event host.
                            <br /><br />
                        </p>
                        <h5 style={{ color: '#020102', width: '100%', textAlign: 'center' }}>Finish Account Setup</h5>
                        <p />
                        <Text
                            label='Email'
                            name='email'
                            value={this.state.email}
                            disabled={true}
                        />
                        <Text
                            label='First name'
                            name='name'
                            value={this.state.name}
                            onChange={this.onChange}
                        />
                        <Text
                            label='Last name'
                            name='lastName'
                            value={this.state.lastName}
                            onChange={this.onChange}
                        />
                        <Text
                            label='New password'
                            name='password'
                            onChange={this.onChange}
                            value={this.state.password}
                        />
                        <Text
                            label='Repeat new password'
                            name='passwordRepeat'
                            onChange={this.onChange}
                            value={this.state.passwordRepeat}
                        />
                        {this.state.message && !this.state.change ? (
                            <div style={{ textAlign: 'center' }}>
                                <Error content={this.state.message} />
                            </div>
                        ) : null}
                        <p />
                        <Button onClick={this.handleSubmit} className="new-button-save" style={{ float: "right", border: 'none' }}>FINISH</Button>
                    </div>
                </div>
            </Card>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/account-setup/FinishAccountSetup.tsx